package com.kinoshazam.crashreporting

import crashreporting.CrashReporterLogger
import io.github.aakira.napier.Napier

object NapierCrashReporterLogger : CrashReporterLogger {
    override fun d(message: String) {
        Napier.d(message, tag = TAG)
    }

    override fun e(message: String, error: Throwable?) {
        Napier.e(message, error, tag = TAG)
    }

    private const val TAG = "CrashReporter"
}
